export type TActivityDataProvider = {
  type: 'redis' | 'momento';
  read: boolean;
  write: boolean;
  env?: string; // env on which the provider is applied
};

export const FULL_MOMENTO_DATA_PROVIDERS: TActivityDataProvider[] = [
  {
    type: 'redis',
    read: true,
    write: true
  },
  {
    type: 'momento',
    read: true,
    write: true,
    env: 'staging'
  },
  {
    type: 'momento',
    read: true,
    write: true,
    env: 'production'
  }
];

export const DUAL_MAIN_MOMENTO_DATA_PROVIDERS: TActivityDataProvider[] = [
  {
    type: 'redis',
    read: true,
    write: true
  },
  {
    type: 'momento',
    read: false,
    write: true,
    env: 'staging'
  },
  {
    type: 'redis',
    read: true,
    write: true,
    env: 'staging'
  },
  {
    type: 'momento',
    read: true,
    write: true,
    env: 'production'
  },
  {
    type: 'redis',
    read: false,
    write: true,
    env: 'production'
  }
];

export const TEST_DATA_PROVIDERS: TActivityDataProvider[] = [
  {
    type: 'redis',
    read: true,
    write: true
  },
  {
    type: 'momento',
    read: true,
    write: true,
    env: 'staging'
  },
  {
    type: 'redis',
    read: false,
    write: true,
    env: 'staging'
  },
  {
    type: 'momento',
    read: false,
    write: true,
    env: 'production'
  },
  {
    type: 'redis',
    read: true,
    write: true,
    env: 'production'
  }
];
